import cn from 'classnames'
import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'

/** Shartnoma to'lovlari bo'limining ikki ko'rinishi: oylik va umumiy qarz. */
export default function ContractTabs() {
    const { pathname } = useLocation()

    return (
        <div className="tabs">
            <ul>
                <li className={cn({ 'is-active': pathname === '/contract-payments' })}>
                    <NavLink to="/contract-payments">По месяцам</NavLink>
                </li>
                <li className={cn({ 'is-active': pathname.startsWith('/contract-payments/debt') })}>
                    <NavLink to="/contract-payments/debt">Общий долг компаний</NavLink>
                </li>
            </ul>
        </div>
    )
}
